import { createDinero } from '@mr-yum/frontend-core/dist/services/createDinero'
import cn from 'classnames'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { LineItemKind, LineItemType } from '@/gql/graphql'

import { TableCell, TableRow } from './shared'
import { LineItemsProps, OrderItemsProps } from './types'

const LineItems = ({
  lineItems,
  parentId = null,
  currency,
}: LineItemsProps) => (
  <div className={cn({ 'ml-2': parentId })}>
    {lineItems
      .filter((item) => item.parentId === parentId)
      .map((item) => (
        <React.Fragment key={item.id}>
          <TableRow>
            {item.type === LineItemType.CardFee &&
            item.kind === LineItemKind.Affirmation ? (
              <>
                <TableCell className="flex-1">{item.name}</TableCell>
              </>
            ) : (
              <>
                <TableCell className="flex-1">
                  {item.name}
                  {item.kind === LineItemKind.Reversal ? (
                    <>
                      {' '}
                      <FormattedMessage
                        description="Item was refunded"
                        defaultMessage="(refunded)"
                        id="N3wToL"
                      />
                    </>
                  ) : (
                    ''
                  )}
                </TableCell>
              </>
            )}

            <TableCell className="text-right">
              {createDinero(item.priceInCents, currency)
                .multiply(item.quantity)
                .toFormat()}
            </TableCell>
          </TableRow>

          {item.quantity > 1 && (
            <div className="mb-2 ml-2 text-foreground-subtle">
              {item.quantity} x{' '}
              {createDinero(item.priceInCents, currency).toFormat()}
            </div>
          )}

          <LineItems
            currency={currency}
            lineItems={lineItems}
            parentId={item.id}
          />
          {item.notes && (
            <div className="mb-2 ml-2 text-foreground-subtle">
              "{item.notes}"
            </div>
          )}
        </React.Fragment>
      ))}
  </div>
)

export const OrderItems = ({ lineItems, currency }: OrderItemsProps) => (
  <>
    <LineItems currency={currency} lineItems={lineItems} />
  </>
)
